import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/useAuthStore';
import { semanticColors } from '@/common/styles/colorTokens';
import { useNavigationStore } from '@/common/store';
import { toastUtils } from '@/common/utils/toastUtils';
import { authService } from '@/services/authService';

const Logout: React.FC = () => {
  const { logout } = useAuthStore();
  const isLogout = useRef<boolean>(false);
  const {  } = useNavigationStore();
  const navigate = useNavigate();

  useEffect(() => {
    const process = async () => {
      isLogout.current = true;
      
      await authService.logout();
      await logout();
      toastUtils.success('로그아웃되었습니다.');
      handleLogin();
      isLogout.current = false;
    };
    !isLogout.current && process();
  }, []);

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <Container>
      <Content>
        <p>처리 중..</p>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, ${semanticColors.background.primary} 0%, ${semanticColors.background.secondary} 100%);
`;

const Content = styled.div`
  text-align: center;
  padding: 2rem;
  max-width: 400px;
  width: 100%;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
`;

export default Logout;
